<template>
    <div>
        <div class="progress-bar" v-if="progressBar"><span :style="{'width': progressBar+'%'}"></span></div>

        <div class="progress-bar__text" v-if="progressBar"><span v-t="'Uploading...'"></span> {{progressBar}}%</div>

        <div v-if="!progressBar">
            <p v-if="show" v-t="'Reposition, resize and rotate your image then click Save'"></p>

            <div id="resizer-demo"></div>

            <div class="resizer-button--left" v-if="show">
                <button @click="rotateImg()" v-t="'Rotate'"></button>
            </div>

            <div class="resizer-button--right" v-if="show" >
                <button @click="removeImg()" v-t="'Reset'"></button>
                <button @click="saveImg()" v-t="'Save'"></button>
            </div>
        </div>

        <div class="field field--file" v-if="!show&&!progressBar">
            <div style="display:none">
                <input type="file" ref="files" class="file" @change="uploadEvent($event.target.files)">
            </div>
            <div class="img-profile" v-if="user.image" :style="{'background-image': 'url('+user.image+')'}"></div>

            <Droppable @upload="uploadFile" v-if="!show&&!user.image" class="file-area" onclick="this.parentElement.getElementsByClassName('file')[0].click()">
                <h3 v-t="'Add Image'"></h3>
                <span v-t="'Click or Drag and Drop a JPG or PNG less than 10Mb'"></span>
                <h3 class="on-hover" v-t="'Drop to Upload'"></h3>
                <span class="on-hover" v-t="'JPG or PNG less than 10Mb'"></span>
            </Droppable>

            <div class="tools" v-if="user.image">
                <div class="replace-links">
                    <a class="replace-link" @click="removeImgFile()" v-t="'Remove Image?'"></a>
                    <a class="replace-link" onclick="this.parentElement.parentElement.parentElement.getElementsByClassName('file')[0].click()" v-t="'Replace Image?'"></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Droppable from '@/components/Droppable.vue'
    import croppie from 'croppie'

    export default {
        props: ['user'],
        components: {
            Droppable,
        },
        data () {
            return {
                resizer: null,
                degrees: 0,
                progressBar: false,
                show: false
            }
        },
        methods: {
            removeImgFile () {
              if(window.confirm("Are you sure you want to remove your profile picture?")){
                this.user.image = null
                this.user.image_clear = true
                this.$emit('save')
              }
            },
            removeImg () {
                this.degrees = 0;
                this.show = false;
                this.resizer.destroy();
            },
            rotateImg () {
                this.degrees += 90;
                if(this.degrees === 270){
                    this.degrees = 0;
                }
                this.resizer.rotate(this.degrees);
            },
            saveImg () {
                var self = this
                this.resizer.result('blob').then(function(blob) {
                    var formData = new window.FormData();
                    formData.append('image', blob);
                    var xhr = new window.XMLHttpRequest();
                    xhr.withCredentials = true;
                    xhr.upload.addEventListener('progress', function(e){
                        self.progressBar = Math.round(e.loaded / e.total * 100);
                    });
                    xhr.onload = function () {
                        var data = JSON.parse(xhr.responseText);
                        self.progressBar = false;
                        self.user.image_clear = false
                        self.user.image = data.image;
                        self.removeImg();
                        self.user.image = data.image;
                    };
                    xhr.open("post", process.env.VUE_APP_API_URL+'/portfolio/image/', true);
                    xhr.send(formData);
                });
            },
            uploadEvent (files){
                var file = files[0]
                this.uploadFile(file)
            },
            uploadFile (file) {
                if (!file.name.match(/\.(jpg|Jpeg|jpeg|png|gif|JPG|JPEG|PNG)$/)) {
                    window.alert('You must choose an image file.');
                } else if( ( file.size / 1024 / 1024) > 10){
                    window.alert('The maximum file size is 10Mb, try compressing your file.');
                } else {
                    var fileReader = new window.FileReader();
                    fileReader.readAsDataURL(file);
                    var self = this

                    fileReader.onload = function(e) {
                        self.degrees = 0;
                        self.show = true;

                        var el = document.getElementById('resizer-demo');
                        self.resizer = new croppie.Croppie(el, {
                            viewport: { width: 300, height: 300 },
                            boundary: { width: 300, height: 300 },
                            showZoomer: true,
                            enforceBoundary: true,
                            enableOrientation: true
                        });
                        self.resizer.bind({
                            url: e.target.result,
                            orientation: 1
                        });

                    };
                }
            }
        }
    }
</script>
